import { render, staticRenderFns } from "./ProcessDocumentSentMailTab.vue?vue&type=template&id=2954b838&scoped=true"
import script from "./ProcessDocumentSentMailTab.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentSentMailTab.vue?vue&type=script&lang=js"
import style0 from "./ProcessDocumentSentMailTab.vue?vue&type=style&index=0&id=2954b838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2954b838",
  null
  
)

export default component.exports